import { isDefaultDocNode, ManagerPhase, PlainExtension } from '@remirror/core';
import { Decoration, DecorationSet } from '@remirror/pm/view';

export class ActiveNodeExtension extends PlainExtension {
  get name() {
    return 'activeNodeExtension';
  }

  createAttributes() {
    return { 'aria-placeholder': this.options.placeholder };
  }

  createPlugin() {
    return {
      state: {
        init: (_, state) => ({
          ...this.options,
          empty: isDefaultDocNode(state.doc, { ignoreAttributes: true }),
        }),
        apply: (tr, pluginState, _, state) => applyState({ pluginState, tr, extension: this, state }),
      },
      props: {
        decorations: (state) => createDecorationSet({ state, extension: this }),
      },
    };
  }

  onSetOptions(props) {
    const { changes } = props;

    if (changes.placeholder.changed && this.store.phase >= ManagerPhase.EditorView) {
      // update the attributes object
      this.store.updateAttributes();
    }
  }
}

function applyState(props) {
  const { pluginState, extension, tr, state } = props;
  if (!tr.selectionSet) return pluginState;
  if (!tr.docChanged) return pluginState;
  return { ...extension.options, empty: isDefaultDocNode(state.doc) };
}

/**
 * Creates a decoration set from the passed through state.
 *
 * @param props - see [[`SharedProps`]]
 */
function createDecorationSet(props) {
  const { extension, state } = props;
  const { activeNodeClass } = extension.options;

  const { selection } = state;
  const { $from } = selection;
  const topLevelPos = $from.before(1);

  const decorations = [];
  state.doc.forEach((node, pos) => {
    if (pos === topLevelPos && selection.$anchor.parent === node) {
      const decoration = Decoration.node(pos, pos + node.nodeSize, {
        class: activeNodeClass,
        'data-node-active': 'true',
      });

      decorations.push(decoration);
    }
  });

  return DecorationSet.create(state.doc, decorations);
}

export default ActiveNodeExtension;
